import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useCallback } from "react";
import PageLayout from "./components/PageLayout";
import DocsLayout from "./components/DocsLayout";
import WaitlistModal from "./components/WaitlistModal";
import LandingPage from "./pages/LandingPage";
import PricingPage from "./pages/PricingPage";
import AboutPage from "./pages/AboutPage";
import BlogPage from "./pages/BlogPage";
import CareersPage from "./pages/CareersPage";
import EnterprisePage from "./pages/EnterprisePage";
import InvestorsPage from "./pages/InvestorsPage";
import DocsPage from "./pages/DocsPage";
import DocPage from "./pages/DocPage";
import CommunityPage from "./pages/CommunityPage";
import ChangelogPage from "./pages/ChangelogPage";
import StudioPage from "./pages/StudioPage";
import CloudPage from "./pages/CloudPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CookiePolicyPage from "./pages/CookiePolicyPage";
import SurveyPage from "./pages/SurveyPage";
import SurveyAdminPage from "./pages/SurveyAdminPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import ScrollToTop from "./components/ScrollToTop";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

const DocsWrapper = ({ children, onOpenWaitlist }) => (
  <div className="min-h-screen bg-white flex flex-col">
    <Navigation onOpenWaitlist={onOpenWaitlist} />
    <DocsLayout>{children}</DocsLayout>
    <Footer />
  </div>
);

function App() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const openWaitlist = useCallback(() => setWaitlistOpen(true), []);
  const closeWaitlist = useCallback(() => setWaitlistOpen(false), []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <WaitlistModal open={waitlistOpen} onClose={closeWaitlist} />
        <Routes>
          <Route path="/" element={<LandingPage onOpenWaitlist={openWaitlist} />} />
          <Route path="/studio" element={<PageLayout onOpenWaitlist={openWaitlist}><StudioPage onOpenWaitlist={openWaitlist} /></PageLayout>} />
          <Route path="/cloud" element={<PageLayout onOpenWaitlist={openWaitlist}><CloudPage onOpenWaitlist={openWaitlist} /></PageLayout>} />
          <Route path="/pricing" element={<PageLayout onOpenWaitlist={openWaitlist}><PricingPage /></PageLayout>} />
          <Route path="/about" element={<PageLayout onOpenWaitlist={openWaitlist}><AboutPage /></PageLayout>} />
          <Route path="/blog" element={<PageLayout onOpenWaitlist={openWaitlist}><BlogPage /></PageLayout>} />
          <Route path="/careers" element={<PageLayout onOpenWaitlist={openWaitlist}><CareersPage /></PageLayout>} />
          <Route path="/enterprise" element={<PageLayout onOpenWaitlist={openWaitlist}><EnterprisePage /></PageLayout>} />
          <Route path="/investors" element={<PageLayout onOpenWaitlist={openWaitlist}><InvestorsPage /></PageLayout>} />
          <Route path="/docs" element={<PageLayout onOpenWaitlist={openWaitlist}><DocsPage /></PageLayout>} />
          <Route path="/docs/:category/:page" element={<DocsWrapper onOpenWaitlist={openWaitlist}><DocPage /></DocsWrapper>} />
          <Route path="/community" element={<PageLayout onOpenWaitlist={openWaitlist}><CommunityPage /></PageLayout>} />
          <Route path="/changelog" element={<PageLayout onOpenWaitlist={openWaitlist}><ChangelogPage /></PageLayout>} />
          <Route path="/privacy" element={<PageLayout onOpenWaitlist={openWaitlist}><PrivacyPage /></PageLayout>} />
          <Route path="/terms" element={<PageLayout onOpenWaitlist={openWaitlist}><TermsPage /></PageLayout>} />
          <Route path="/cookies" element={<PageLayout onOpenWaitlist={openWaitlist}><CookiePolicyPage /></PageLayout>} />
          <Route path="/survey" element={<SurveyPage />} />
          <Route path="/survey/admin" element={<SurveyAdminPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/products" element={<LandingPage onOpenWaitlist={openWaitlist} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
